<script setup lang="ts">
import { NuxtImg } from "#components";
import { ref, toRefs } from '#imports';
import { useI18n } from '#imports';

const props = defineProps<{
  box: any;
}>();

const { box } = toRefs(props);
const { t } = useI18n();

const activeTab = ref(1);

if (box.value?.before_after_radio === "after") {
  activeTab.value = 2;
}
</script>
<template>
  <div class="md:px-2 lg:px-4 min-h-full">
    <div class="tab_item pb-2">
      <div
        class="bg-cust_cream p-2 flex text-base md:text-lg xl:text-xl font-redit_sans rounded-lg mb-6"
      >
        <button
          class="tabBtn vorher-btn w-1/2 h-8 flex items-center justify-center rounded-md transition-colors duration-300 hover:text-cust_green"
          :class="{ 'active font-bold': activeTab === 1 }"
          @click="activeTab = 1"
        >
          {{ t("pluebel-cms-elements-before-after-box.before") }}
        </button>
        <button
          class="tabBtn naccer-btn w-1/2 h-8 flex items-center justify-center rounded-md transition-colors duration-300 hover:text-cust_green"
          :class="{ 'active font-bold': activeTab === 2 }"
          @click="activeTab = 2"
        >
          {{ t("pluebel-cms-elements-before-after-box.after") }}
        </button>
      </div>
      <div class="tab-item-data">
        <div class="tabData vorher-data" :class="{ show: activeTab === 1 }">
          <div class="mb-6">
            <figure class="rounded-3xl overflow-hidden w-full aspect-[3/4] relative">
              <NuxtImg
                v-if="box.before_image?.url"
                loading="lazy"
                format="webp"
                :src="box.before_image?.url"
                :alt="box.before_image?.alt || box.before_image?.fileName"
                class="w-full h-auto object-cover"
              />
            </figure>
          </div>
          <div class="flex justify-center md:block">
            <ul
              v-if="box.product_links?.length > 0"
              class="text-base md:text-lg xl:text-xl w-fit"
            >
              <template v-for="(link, index) in box.product_links" :key="index">
                <li
                  class="before:bg-[var(--dynamic-color)]"
                  :style="{ '--dynamic-color': link?.color_hex }"
                >
                  <SharedButton :button="link?.product_link" class="!no-underline">
                    {{ link?.product_link?.title }}
                  </SharedButton>
                </li>
              </template>
            </ul>
          </div>
        </div>
        <div class="tabData naccer-data" :class="{ show: activeTab === 2 }">
          <div class="mb-6">
            <figure class="rounded-3xl overflow-hidden w-full aspect-[3/4] relative">
              <NuxtImg
                v-if="box.after_image?.url"
                loading="lazy"
                format="webp"
                :src="box.after_image?.url"
                :alt="box.after_image?.alt || box.after_image?.fileName"
                class="w-full h-auto object-cover"
              />
            </figure>
          </div>
          <div class="flex justify-center md:block">
            <ul
              v-if="box.product_links?.length > 0"
              class="text-base md:text-lg xl:text-xl w-fit"
            >
              <template v-for="(link, index) in box.product_links" :key="index">
                <li
                  class="before:bg-[var(--dynamic-color)]"
                  :style="{ '--dynamic-color': link?.color_hex }"
                >
                  <SharedButton :button="link?.product_link" class="!no-underline">
                    {{ link?.product_link?.title }}
                  </SharedButton>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
